<script lang="ts">
  // BJL-CHECK: Card (used) — the whole itinerary is one tap target, which is exactly bjl
  // Card's `clickable` mode (role=button + Enter/Space). See artifacts/deviations/PlanPage.md.
  import { Card } from '@byjackli-labs/ui/Card'
  import { Colors } from '../../ui/colors'
  import { Type } from '../../ui/theme'
  import type { Itinerary } from '../../services/api'
  import { fmtDuration, fmtTime, walkMinutes } from './format'
  import RideBadge from './RideBadge.svelte'
  import LiveDot from './LiveDot.svelte'

  interface Props {
    it: Itinerary
    onPress: () => void
  }

  const { it, onPress }: Props = $props()

  const hasLive = $derived(it.legs.some((l) => l.mode !== 'walk' && l.realtime))
</script>

<Card
  clickable
  onclick={onPress}
  ariaLabel="Trip departing {fmtTime(it.departureTime)}, arriving {fmtTime(it.arrivalTime)}"
>
  <div style="display: flex; flex-direction: column; gap: 8px; width: 100%; text-align: left;">
  <div style="display: flex; align-items: baseline; gap: 8px;">
    <span style="color: {Colors.text}; {Type.title};">
      {fmtTime(it.departureTime)} → {fmtTime(it.arrivalTime)}
    </span>
    <span
      style="color: {Colors.textSecondary}; {Type.body}; font-weight: 600; margin-left: auto;"
    >{fmtDuration(it.durationSec)}</span>
  </div>
  <div style="display: flex; align-items: center; gap: 6px; flex-wrap: wrap;">
    {#each it.legs as leg, i (i)}
      <span style="display: flex; align-items: center; gap: 6px;">
        {#if i > 0}<span style="color: {Colors.textMuted}; {Type.caption};">›</span>{/if}
        {#if leg.mode === 'walk'}
          <span style="color: {Colors.textSecondary}; {Type.body};">🚶{walkMinutes(leg)}</span>
        {:else}
          <RideBadge {leg} size={22} />
        {/if}
      </span>
    {/each}
    <span style="margin-left: auto; display: flex; align-items: center; gap: 8px;">
      {#if hasLive}<LiveDot />{/if}
      <span style="color: {Colors.textMuted}; {Type.caption};">
        {it.transfers === 0 ? 'direct' : `${it.transfers} transfer${it.transfers > 1 ? 's' : ''}`}
      </span>
    </span>
  </div>
  </div>
</Card>
